import ProductPassport from './ProductPassport';

export default ProductPassport;
